(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gulf-weather"] && !Shopify.designMode) return;
  try {
    
const gulfLocalMidnight=(y,m,d)=>{const target=Date.UTC(y,m-1,d);let value=target;const formatter=new Intl.DateTimeFormat('en-NZ',{timeZone:'Pacific/Auckland',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});for(let i=0;i<3;i++){const p=Object.fromEntries(formatter.formatToParts(new Date(value)).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));value+=target-Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);}return value;};

function initGulfTides(root){
  root.querySelectorAll('[data-gulf-tides]').forEach(panel=>{
    const data=JSON.parse(panel.querySelector('[data-tide-data]').textContent),copy=JSON.parse(panel.querySelector('[data-tide-copy]').textContent),select=panel.querySelector('[data-tide-date]'),list=panel.querySelector('[data-tide-list]'),next=panel.querySelector('[data-tide-next]');
    const dateFormat=new Intl.DateTimeFormat('en-NZ',{timeZone:'Pacific/Auckland',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
    const labelFormat=new Intl.DateTimeFormat('en-NZ',{timeZone:'Pacific/Auckland',weekday:'short',day:'numeric',month:'short'});
    const make=(tag,text,className)=>{const el=document.createElement(tag);el.textContent=text;if(className)el.className=className;return el;};
    const localParts=()=>Object.fromEntries(dateFormat.formatToParts(new Date()).filter(p=>p.type!=='literal').map(p=>[p.type,p.value]));
    const dateKey=p=>p.year+'-'+p.month+'-'+p.day;
    const keyAfter=(key,offset)=>{const [y,m,d]=key.split('-').map(Number);return new Date(Date.UTC(y,m-1,d+offset)).toISOString().slice(0,10);};
    const dateLabel=key=>{const [y,m,d]=key.split('-').map(Number);return labelFormat.format(new Date(gulfLocalMidnight(y,m,d)+43200000));};
    const showDay=()=>{list.replaceChildren();const events=data[select.value];if(!events){list.append(make('p',copy.missing));return;}events.forEach(([time,height,kind])=>{const card=make('div','','gulf-tides__event');card.append(make('strong',(kind==='H'?'↑ ':'↓ ')+(kind==='H'?copy.high:copy.low)),make('b',time),make('span',height.toFixed(1)+' '+copy.metres));list.append(card);});};
    let lastKey='';
    const refresh=()=>{
      const p=localParts(),today=dateKey(p),clock=p.hour+':'+p.minute+':'+p.second;
      if(today!==lastKey){const chosen=select.value;select.replaceChildren();for(let i=0;i<14;i++){const key=keyAfter(today,i),label=(i===0?copy.today:i===1?copy.tomorrow:dateLabel(key));const option=make('option',label);option.value=key;select.append(option);}select.value=data[chosen]&&chosen>=today&&chosen<=keyAfter(today,13)?chosen:today;lastKey=today;showDay();}
      const upcoming=[];for(let i=0;i<3;i++){const key=keyAfter(today,i);(data[key]||[]).forEach(([time,height,kind])=>{if(key>today||time+':00'>=clock)upcoming.push({key,time,height,kind});});}
      next.replaceChildren();['H','L'].forEach(kind=>{const event=upcoming.find(e=>e.kind===kind),card=make('div','','gulf-tides__next-card');card.append(make('strong',kind==='H'?copy.nextHigh:copy.nextLow));if(event){card.append(make('b',event.time),make('small',(event.key===today?copy.today:event.key===keyAfter(today,1)?copy.tomorrow:dateLabel(event.key))+' · '+event.height.toFixed(1)+' '+copy.metres));}else card.append(make('small',copy.missing));next.append(card);});
    };
    select.addEventListener('change',showDay);refresh();
    const interval=setInterval(()=>{if(!root.isConnected){clearInterval(interval);return;}refresh();},60000);
  });
}

function initGulfWeather(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const copy=JSON.parse(root.querySelector('[data-gulf-copy]').textContent),track=root.querySelector('.gulf-weather__track'),slides=[...root.querySelectorAll('.gulf-weather__slide')],tabs=[...root.querySelectorAll('[data-slide]')];
  let current=0;
  const resize=()=>{const height=slides[current]?.offsetHeight;if(height)track.style.height=height+'px';};
  const sizing=new ResizeObserver(resize);slides.forEach(slide=>sizing.observe(slide));resize();
  const move=index=>{current=(index+slides.length)%slides.length;track.scrollTo({left:slides[current].offsetLeft-slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});tabs.forEach((tab,i)=>tab.setAttribute('aria-pressed',String(i===current)));resize();};
  tabs.forEach(tab=>tab.addEventListener('click',()=>{move(Number(tab.dataset.slide));}));
  root.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{move(current+Number(button.dataset.direction));}));
  const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){current=slides.indexOf(entry.target);tabs.forEach((tab,i)=>tab.setAttribute('aria-pressed',String(i===current)));resize();}});},{root:track,threshold:.6});
  slides.forEach(slide=>observer.observe(slide));
  initGulfTides(root);
  const refresh=setInterval(()=>{if(!root.isConnected){clearInterval(refresh);observer.disconnect();sizing.disconnect();return;}if(document.hidden||!matchMedia('(min-width:1024px)').matches)return;root.querySelectorAll('[data-camera-snapshot]').forEach(image=>{const url=new URL(image.src);url.searchParams.set('_updated',Date.now());image.src=url.href;});root.querySelectorAll('.gulf-weather__slide--wind iframe').forEach(frame=>{const url=new URL(frame.src);url.searchParams.set('_updated',Date.now());frame.src=url.href;});},300000);

}
document.querySelectorAll('[data-gulf-weather]').forEach(initGulfWeather);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-gulf-weather]').forEach(initGulfWeather));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
